import app from "./modules/app/appReducer";

const reducers = { app };

export default reducers;
